import CryptoJS from 'crypto-js';

/**
 * AES对称加密
 * @param {*} key // 16 字节密钥（AES-128），可以使用更长的密钥（192 或 256 位）
 * @param {*} iv // 16 字节初始向量（IV）
 * @param {*} text
 * @returns
 */
export function encryptAES(key, iv, text) {
  const encrypted = CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(key), {
    iv: CryptoJS.enc.Utf8.parse(iv),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
}

// AES 解密
export function decryptAES(key, iv, encryptedText) {
  const decrypted = CryptoJS.AES.decrypt(encryptedText, CryptoJS.enc.Utf8.parse(key), {
    iv: CryptoJS.enc.Utf8.parse(iv),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}
